import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { FormActionDrawer, IntroText, Loader } from "../../../components";
import { Box, Button, Grid, Typography, Paper } from "@material-ui/core";
import { GGV_GET_AVAILABLE_TIMES } from "../../../queries";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const ScheduleTimeAppointmentOne = ({
  scheduleData,
  setDrawerClearance,
  isSubmitting,
  updateScheduleData
}) => {
  const [selectedTime, setSelectedTime] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    if (!scheduleData.date || !scheduleData.location) {
    }
  }, [scheduleData]);

  const { data, loading, error } = useQuery(GGV_GET_AVAILABLE_TIMES, {
    variables: {
      location: scheduleData.location,
      date: scheduleData.date
    },
    fetchPolicy: "no-cache"
  });

  const handleNext = () => {
    // TODO: Post back to API to reserve this slot

    updateScheduleData({ appointmentOneTime: selectedTime });
  };

  if (loading) return <Loader />;
  if (error)
    return (
      <Typography color="error">
        {t("schedule.time_appointment_one.error_api")}
      </Typography>
    );

  const { ggvAvailableTimes: availableTimes } = data;

  return (
    <Box data-cy="schedule-screen-time-appointment-one">
      {availableTimes &&
      availableTimes.available_times &&
      availableTimes.available_times.length ? (
        <>
          {scheduleData.locationDetails &&
            scheduleData.locationDetails.address &&
            scheduleData.locationDetails.name && (
              <Box mb={2}>
                <Alert severity="success">
                  <AlertTitle>{scheduleData.locationDetails.name}</AlertTitle>
                  {scheduleData.locationDetails.address}
                </Alert>
              </Box>
            )}
          <Paper>
            <Box p={2}>
              <IntroText>
                {t("schedule.time_appointment_one.intro_text")}
              </IntroText>
              <Grid container direction="column" spacing={1}>
                {availableTimes.available_times.map(time => (
                  <Grid item xs key={`time-${time.value}`}>
                    <Button
                      data-cy="button-time-select"
                      fullWidth
                      variant={
                        time.value === selectedTime ? "contained" : "outlined"
                      }
                      color={
                        time.value === selectedTime ? "primary" : "default"
                      }
                      onClick={() => setSelectedTime(time.value)}
                    >
                      {time.label}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Paper>
        </>
      ) : (
        <Typography color="error">
          {t("schedule.time_appointment_one.error_empty")}
        </Typography>
      )}
      {selectedTime && (
        <FormActionDrawer
          setDrawerClearance={setDrawerClearance}
          handleNext={e => handleNext()}
          loading={isSubmitting}
        />
      )}
    </Box>
  );
};

export { ScheduleTimeAppointmentOne };
